export default __webpack_public_path__ + "KaTeX_Main-Italic.ab751a9e86a16f178b79f99db42d3ea2.woff2";